import { GoogleMap } from "../../../../components/Map"
import { TP_Building } from "./types"

const LocationView = (props: TP_Building) => {

    return (
        <>{props.address.longitude && 
            <GoogleMap width={'100%'} height={'200px'} markers={[ {title: props.description, latitude: props.address.latitude, longitude: props.address.longitude }]}   ></GoogleMap>
        }</>
    )
}

export default LocationView